module.exports = __webpack_public_path__ + "img/alert-success.f65e330d.svg";